import { ResourceApi } from 'services/api'
import { TituloIntegracion } from './Integracion'

export class TituloIntegracionApi extends ResourceApi<TituloIntegracion> {
  constructor(tituloId: Identifier) {
    super('/api/titulos/:tituloId/integraciones', { tituloId })
  }
}
